var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "pageTitle"
  }, [_vm._v("監控來源資料下載")]), _c('div', {
    staticClass: "borderColor mb-4 p-3"
  }, [_c('div', {
    staticClass: "d-flex flex-wrap align-items-start"
  }, [_c('div', {
    staticClass: "field mr-4"
  }, [_c('label', {
    staticClass: "fieldLabel"
  }, [_vm._v("API 來源廠商")]), _c('b-form-select', {
    staticClass: "sourceSelect",
    attrs: {
      "options": _vm.sourceOptions
    },
    model: {
      value: _vm.provider,
      callback: function callback($$v) {
        _vm.provider = $$v;
      },
      expression: "provider"
    }
  })], 1), _c('div', {
    staticClass: "field mr-4"
  }, [_c('label', {
    staticClass: "fieldLabel"
  }, [_vm._v("案場")]), _c('b-form-select', {
    staticClass: "plantSelect",
    attrs: {
      "options": _vm.plantOptions,
      "disabled": !_vm.plants.length
    },
    model: {
      value: _vm.plantNo,
      callback: function callback($$v) {
        _vm.plantNo = $$v;
      },
      expression: "plantNo"
    }
  }), _vm.lastDate ? _c('div', {
    staticClass: "fieldHint mt-1"
  }, [_vm._v(" 資料最新到 " + _vm._s(_vm.lastDate) + " ")]) : _vm._e()], 1), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "fieldLabel"
  }, [_vm._v(" 日期區間 "), _c('span', {
    staticClass: "fieldHint"
  }, [_vm._v("最多 " + _vm._s(_vm.maxDays) + " 天")])]), _c('date-picker', {
    staticClass: "rangePicker",
    attrs: {
      "range": "",
      "value-type": "format",
      "format": "YYYY-MM-DD",
      "disabled-date": _vm.isDateAfterToday,
      "clearable": false,
      "placeholder": "選擇開始與結束日期"
    },
    model: {
      value: _vm.dateRange,
      callback: function callback($$v) {
        _vm.dateRange = $$v;
      },
      expression: "dateRange"
    }
  }), _c('div', {
    staticClass: "presetRow"
  }, _vm._l(_vm.datePresets, function (p) {
    return _c('button', {
      key: p.label,
      staticClass: "presetChip",
      class: {
        active: _vm.activePreset === p.label
      },
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          _vm.dateRange = _vm.presetRange(p);
        }
      }
    }, [_vm._v(" " + _vm._s(p.label) + " ")]);
  }), 0)], 1)]), _c('div', {
    staticClass: "itemsBlock",
    class: {
      isEmpty: !_vm.deviceOptions.length
    }
  }, [_vm.loadingOptions ? _c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "secondary"
    }
  }) : !_vm.deviceOptions.length ? _c('div', {
    staticClass: "emptyHint"
  }, [_c('i', {
    staticClass: "fas fa-arrow-up mr-2"
  }), _vm._v("這個來源目前沒有可下載的資料 ")]) : [_c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_c('label', {
    staticClass: "fieldLabel mb-0"
  }, [_vm._v("下載裝置")]), _c('button', {
    staticClass: "linkBtn ml-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.setAll(true);
      }
    }
  }, [_vm._v(" 全選 ")]), _c('button', {
    staticClass: "linkBtn ml-2",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.setAll(false);
      }
    }
  }, [_vm._v(" 全部清除 ")]), _c('span', {
    staticClass: "selectedCount ml-auto"
  }, [_vm._v(" 已選 " + _vm._s(_vm.devices.length) + " / " + _vm._s(_vm.deviceOptions.length) + " ")])]), _c('b-form-checkbox-group', {
    staticClass: "optionGrid",
    attrs: {
      "options": _vm.deviceOptions
    },
    model: {
      value: _vm.devices,
      callback: function callback($$v) {
        _vm.devices = $$v;
      },
      expression: "devices"
    }
  }), _c('b-form-checkbox', {
    staticClass: "realOnly",
    model: {
      value: _vm.realOnly,
      callback: function callback($$v) {
        _vm.realOnly = $$v;
      },
      expression: "realOnly"
    }
  }, [_vm._v(" 只要真實量測值 "), _c('small', [_vm._v(" 不勾則含內插補值（" + _vm._s(_vm.interpolatedHint) + "的列是補的）；檔案裡的 "), _c('code', [_vm._v("是否內插值 is_interpolated")]), _vm._v(" 欄可以事後自己過濾 ")])])]], 2), _c('div', {
    staticClass: "footerRow"
  }, [_c('div', {
    staticClass: "summary"
  }, [_vm.plantNo && _vm.devices.length ? [_vm._v(" 將下載 "), _c('strong', [_vm._v(_vm._s(_vm.days))]), _vm._v(" 天 × "), _c('strong', [_vm._v(_vm._s(_vm.devices.length))]), _vm._v(" 台，每分鐘一列 "), _vm.days > _vm.maxDays ? _c('span', {
    staticClass: "warn"
  }, [_vm._v(" — 超過 " + _vm._s(_vm.maxDays) + " 天上限 ")]) : _vm._e()] : [_vm._v(" 選好來源、案場、日期與裝置後即可下載 ")]], 2), _c('button', {
    staticClass: "confirmButton downloadBtn",
    class: {
      disableButton: !_vm.canDownload
    },
    attrs: {
      "disabled": !_vm.canDownload
    },
    on: {
      "click": _vm.download
    }
  }, [_vm.downloading ? _c('i', {
    staticClass: "fas fa-circle-notch fa-spin mr-2"
  }) : _c('i', {
    staticClass: "fas fa-file-excel mr-2"
  }), _vm._v(" " + _vm._s(_vm.downloading ? '產檔中…' : '下載 Excel') + " ")])]), _vm.downloading ? _c('div', {
    staticClass: "loadingHint"
  }, [_vm._v(" 資料量大時檔案要跑一分鐘左右，請不要關閉頁面 ")]) : _vm._e()])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };